const getDynamicSchoolYear = (onylFirstPart) => {
  const today = new Date();
  const beginingOfSchoolYear = new Date(today.getFullYear(), 8, 1);
  const endOfSchoolYear = new Date(today.getFullYear() + 1, 5, 21);
  const isCurrentSchoolYear =
    beginingOfSchoolYear <= today && today <= endOfSchoolYear;

  if (!isCurrentSchoolYear) {
    if (today < beginingOfSchoolYear) {
      return !onylFirstPart
        ? today.getFullYear() -
            1 +
            "/" +
            today.getFullYear().toString().slice(-2)
        : today.getFullYear() - 1;
    } else {
      return !onylFirstPart
        ? today.getFullYear() +
            1 +
            "/" +
            (today.getFullYear() + 2).toString().slice(-2)
        : today.getFullYear() + 1;
    }
  } else {
    return !onylFirstPart
      ? today.getFullYear() +
          "/" +
          (today.getFullYear() + 1).toString().slice(-2)
      : today.getFullYear();
  }
};

export default getDynamicSchoolYear;
